<template>
    <div>
      <!-- Form Group -->
      <div class="form-group mb-3">
        <label for="level" class="form-label">
          <i class="bi bi-book"></i> Student Level
        </label>
        <input
          type="number"
          id="level"
          v-model="level"
          class="form-control"
          placeholder="Enter Student Level"
          required
        />

        <label for="price" class="form-label">
          <i class="bi bi-book"></i> Price
        </label>
        <input
          type="number"
          id="price"
          v-model="price"
          class="form-control"
          placeholder="Enter Price For Level"
          required
        />
        
        <div v-if="errorMessage" class="alert alert-danger mt-2">
          <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
        </div>
        <div v-if="successMessage" class="alert alert-success mt-2">
          <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
        </div>
        <button @click="submitForm" class="btn btn-primary mt-3">
          <i class="bi bi-save"></i> Save
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        level: '',
        price: '',
        successMessage: null,
        errorMessage: null,
      };
    },
    methods: {
      async submitForm() {
        this.successMessage = null; // Reset success message
        this.errorMessage = null;   // Reset error message
  
        try {
          const response = await axios.post('/insert-student-level', {
            level: this.level,
            price: this.price
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            }
          });
  
          // Handle successful submission
          this.successMessage = response.data.message; // Set the success message
          this.level = ''; // Clear the form
          this.price = ''; // Clear the form
        } catch (error) {
          if (error.response && error.response.data) {
            // Handle errors from Laravel
            this.errorMessage = error.response.data.message || 'An error occurred.';
          } else {
            this.errorMessage = 'An error occurred.';
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any specific styles you need */
  </style>
  